import React from "react";
import iwcLogo from "../images/iwc-logo.png";
import ReactWhatsapp from "react-whatsapp";

const Footer = () => {
  return (
    <footer>
      <div className="w-full bg-primaryYellow font-semibold">
        <section
          id="footer-social"
          className="w-full h-32 grid grid-cols-8 gap-3 content-center text-gray-200 p-5"
        >
          <div className="text-black self-center col-span-2">
            <hr />
          </div>

          {/* Discord */}
          <a
            href="https://discord.com/invite/cXuG6SwT"
            className="w-8 h-8 place-self-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 245 240"
              className="w-6 h-6 text-black"
              fill="currentColor"
            >
              <path d="M104.4 104.1c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.3-5 10.2-11.1.1-6.2-4.5-11.1-10.2-11.1zm36.3 0c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.3-5 10.2-11.1.1-6.2-4.5-11.1-10.2-11.1z" />
              <path d="M189.5 20h-134A15.4 15.4 0 0040 35.5v169.1A15.4 15.4 0 0055.5 220h114l-5.3-18.3 12.8 11.9 12 11.1 21.2 19V35.5A15.4 15.4 0 00189.5 20zm-31.7 135s-2.9-3.5-5.2-6.6c10.3-2.9 14.2-9.3 14.2-9.3-3.2 2.1-6.3 3.6-9 4.6-3.9 1.7-7.6 2.8-11.2 3.5-7.4 1.4-14.2 1-20.1-.1-4.4-.8-8.2-2-11.4-3.5-1.8-.8-3.8-1.7-5.8-2.9-.2-.1-.3-.2-.5-.3-.1-.1-.2-.1-.3-.2-1.3-.7-2-1.2-2-1.2s3.7 6.2 13.4 9.2c-2.3 3.1-5.3 6.8-5.3 6.8-17.6-.6-24.3-12.1-24.3-12.1 0-25.5 11.4-46.1 11.4-46.1 11.4-8.4 22.3-8.1 22.3-8.1l.8 1c-14.3 4.1-20.9 10.3-20.9 10.3s1.8-1 4.8-2.3c8.7-3.8 15.6-4.9 18.4-5.2.5-.1.9-.2 1.4-.2 5.2-.7 11.1-.9 17.1-.2 8 .9 16.6 3.2 25.4 7.9 0 0-6.2-5.9-19.6-10l1.1-1.3s10.9-.3 22.3 8.1c0 .1 11.4 20.6 11.4 46.1.1 0-6.7 11.5-24.3 12.1z" />
            </svg>
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/investwithcertainty?mibextid=ZbWKwL"
            className="w-8 h-8 place-self-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="w-6 h-6 text-black"
              viewBox="0 0 24 24"
            >
              <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2v-3h2v-2.3c0-2 1.2-3.2 3-3.2.9 0 1.8.2 1.8.2v2h-1c-1 0-1.3.6-1.3 1.2V12h2.2l-.4 3h-1.8v7A10 10 0 0 0 22 12Z" />
            </svg>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/investwithcertainty?igsh=MWZtMTFtM3dqYWtvMQ=="
            className="w-8 h-8 place-self-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="w-6 h-6 text-black"
              viewBox="0 0 24 24"
            >
              <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7Zm0 2h10c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3Zm10.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z" />
            </svg>
          </a>

          {/* WhatsApp */}
          <ReactWhatsapp
            className="w-8 h-8 place-self-center"
            number="+65 8083 6872"
            message="Hi! I was referred to you by your website! I would like to know more about IWC and 1KadayClub."
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6 text-black"
            >
              <path d="M20.52 3.48A11.82 11.82 0 0012 0a11.81 11.81 0 00-10 17.94L0 24l6.18-1.95A11.81 11.81 0 0012 24a11.8 11.8 0 008.36-20.52zM12 21.83a9.82 9.82 0 01-5-1.36l-.36-.21-3.67 1.15 1.17-3.58-.23-.38A9.81 9.81 0 1112 21.83zm5.53-7.59c-.3-.15-1.79-.88-2.07-.98s-.48-.15-.68.15-.78.98-.95 1.18-.35.22-.65.07a8.01 8.01 0 01-2.36-1.46 8.93 8.93 0 01-1.67-2.07c-.18-.3 0-.46.13-.6.13-.13.3-.35.45-.52s.2-.3.3-.5.05-.38-.03-.52c-.08-.15-.68-1.65-.93-2.26-.25-.6-.5-.52-.68-.53h-.6c-.2 0-.52.08-.8.38a3.37 3.37 0 00-1.12 2.52c0 1.49 1.07 2.93 1.22 3.13.15.2 2.1 3.2 5.1 4.47.71.3 1.26.48 1.7.61a4.2 4.2 0 001.93.12c.59-.09 1.79-.73 2.05-1.43.25-.7.25-1.3.18-1.43-.07-.12-.28-.2-.6-.35z" />
            </svg>
          </ReactWhatsapp>

          <div className="text-black self-center col-span-2">
            <hr />
          </div>
        </section>

        <section id="footer-links" className="text-black grid grid-rows-3 px-5">
          <div className="place-self-center">
            <img src={iwcLogo} alt="IWC Logo" />
          </div>
          <div className="place-self-center text-center">
            <p>© 2024 Invest With Certainty</p>
            <p>All Rights Reserved</p>
          </div>
          <div className="grid grid-cols-3 place-items-center text-center">
            <div className="place-self-center">
              <a className="underline" href="/privacy">
                Privacy Policy
              </a>
            </div>
            <div className="place-self-center">
              <a className="underline" href="/terms">
                Terms and Conditions
              </a>
            </div>
            <div className="place-self-center">
              <a className="underline" href="/contact">
                Contact Us
              </a>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
